import React, { useMemo, useState, useContext } from "react";
import ImagePickerUIKit from "./image";
import SourceImage from "./source-image";
import { GrigoraDashboardContext } from "../dashboard/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faPlus,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Popover, PopoverAnchor, PopoverContent } from "./popover";
import { Tooltip } from "../input";
import { IconsRenderer } from "../../assets/icon-pack";
import ModalInput from "./modal";
import { INPUT_LIMITS } from "../input-limits";

function ImagePickerWithRender({ value, onChange }) {
  const [srcModal, setSrcModal] = useState(false);

  const [featuredImagePopover, setFeaturedImagePopover] = useState(false);
  const [imageOptionsPopover, setImageOptionsPopover] = useState(false);
  const { projectID } = useContext(GrigoraDashboardContext) ?? {};

  return (
    <>
      <div className="md:w-[300px] md:h-[200px] overflow-hidden rounded-[21px] relative">
        {value?.src ? (
          <>
            <Popover
              placement="left"
              open={featuredImagePopover}
              onOpenChange={setFeaturedImagePopover}
            >
              <PopoverAnchor
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setFeaturedImagePopover(true);
                }}
                className="absolute z-[100]  top-2 right-3 w-4 flex h-4 items-center justify-center p-3 cursor-pointer hover:bg-gray-100 duration-300  rounded-full bg-white "
              >
                <Tooltip
                  text={`Featured Image Options`}
                  mouseEnterDelay={1}
                  placement="left"
                >
                  <div>
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                  </div>
                </Tooltip>
              </PopoverAnchor>
              <PopoverContent className="p-2 !rounded-[21px] w-[150px] outline-none flex flex-col gap-1">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setImageOptionsPopover(true);
                  }}
                  className="flex gap-2 items-center hover:bg-globe-primary hover:text-white w-full p-2 rounded-[21px] bg-ui-light-white text-grigora-base duration-300 outline-none "
                >
                  <IconsRenderer
                    name="Settings"
                    className="w-[20px] h-[20px]"
                  />
                  <span>Image Options</span>
                </button>
                <div className="">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onChange(undefined);
                    }}
                    className="flex gap-2 items-center hover:bg-globe-primary hover:text-white w-full p-2 rounded-[21px] bg-ui-light-white text-grigora-base duration-300 outline-none "
                  >
                    <IconsRenderer
                      name="Delete"
                      className="w-[20px] h-[20px]"
                    />
                    <span>Delete</span>
                  </button>
                </div>
              </PopoverContent>
            </Popover>
            <div className="cursor-pointer w-full h-full relative">
              <SourceImage
                projectID={projectID}
                src={value?.src}
                srcMode={value?.srcMode}
                onClick={() => {
                  setSrcModal(true);
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div
              onClick={() => {
                setSrcModal(true);
              }}
              className="bg-[#00000021] w-full h-full relative cursor-pointer rounded-[21px] duration-300 hover:bg-[#00000036]"
            >
              <div className="absolute top-[50%] left-[50%] w-[36px] flex h-[36px] bg-white translate-x-[-50%] translate-y-[-50%] rounded-full items-center justify-center">
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </div>
          </>
        )}
        <ImagePickerUIKit
          src={value?.src}
          srcMode={value?.srcMode}
          onChange={(src, srcMode) => {
            onChange({ src, srcMode });
          }}
          opened={srcModal}
          setOpened={setSrcModal}
        />
      </div>
      <ModalInput
        isOpened={imageOptionsPopover}
        onOutsideClick={() => {
          setImageOptionsPopover(false);
        }}
      >
        <div className="grigora-collaborator-container bg-white text-black mw-[50vw]  md:w-[30vw] w-[85vw]  rounded-[21px]">
          <div className="flex flex-row justify-between bg-white p-4 pb-0 rounded-t-[21px] font-bold">
            <div className="modal-heading">Image Options</div>
            <div
              className="cursor-pointer"
              onClick={(e) => setImageOptionsPopover(false)}
            >
              <FontAwesomeIcon icon={faTimes} />
            </div>
          </div>
          <div className="p-4 bg-ui-light-white m-4 rounded-[21px]">
            <label className="text-grigora-base">Alt Tag</label>
            <input
              type="text"
              name="alttag"
              minLength={INPUT_LIMITS["image-alt-text"].minlength}
              maxLength={INPUT_LIMITS["image-alt-text"].maxlength}
              className="rounded-t-[21px] my-3 w-full p-4 outline-none text-grigora-base rounded-[21px] shadow-one bg-white h-[42px] text-grigora-base"
              placeholder="Alt Tag"
              value={value?.alt}
              onChange={(e) => {
                onChange({ ...value, alt: e.target.value });
              }}
            />
          </div>
        </div>
      </ModalInput>
    </>
  );
}

export default ImagePickerWithRender;
